import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";
import { SkeletonLoader } from "@circle-react-shared/uikit/SkeletonLoader";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const Value = () => {
  const { previewMutation } = usePaywallCheckoutContext();
  const preview = previewMutation.data;

  if (!preview || previewMutation.isLoading) {
    return (
      <div className="flex flex-row items-center gap-x-1.5">
        <SkeletonLoader variant="row" lg />
      </div>
    );
  }

  const shouldShowOriginalValue =
    !preview?.trial_period?.free && preview.first_payment?.discount < 0;

  return (
    <div className="flex flex-row gap-x-1.5">
      {shouldShowOriginalValue && (
        <Typography.LabelMd weight="semibold" color="text-disabled">
          <span className="line-through">
            {formatPaywallCurrencyAmount(
              preview.currency,
              preview.first_payment.price_amount,
              { includeCurrencyCode: false },
            )}
          </span>
        </Typography.LabelMd>
      )}
      <Typography.LabelMd weight="semibold">
        {formatPaywallCurrencyAmount(preview.currency, preview.amount_due_now)}
      </Typography.LabelMd>
    </div>
  );
};
